<script setup lang="ts">
const { limit, total } = defineProps<{ limit: number; total: number }>()

const emit = defineEmits<{ loadMore: [] }>()
</script>

<template>
  <div class="load-more">
    <button v-if="total > limit" class="load-more__button" @click="emit('loadMore')">
      Tải thêm ({{ limit }}/{{ total }} games)
    </button>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/pages/common/load-more-button.scss';
</style>
